import Vue from 'vue';
import { api } from "../../services/Api.js";

export function update_news_item({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    return new Promise((resolve)=>{

    // make api call
    api
      .post(school,"update_news_item.php",payload)
      .then( result =>{ 
        // no toast here, because upload images
        resolve(result);
      })
      .catch( error => {
        Vue.$toaster.toast("store: update_news_item: "+error);
      })

    });// promise

  }